import { defineMessages } from 'react-intl';

const messages = defineMessages({
  productInformation: {
    id: 'productSummary.productInformation',
    defaultMessage: 'Product information',
    fields: {
      make: {
        id: 'productSummary.productInformation.make',
        defaultMessage: 'Make',
      },
      model: {
        id: 'productSummary.productInformation.model',
        defaultMessage: 'Model',
      },
      name: {
        id: 'productSummary.productInformation.name',
        defaultMessage: 'Name',
      },
      selling_price: {
        id: 'productSummary.productInformation.selling_price',
        defaultMessage: 'Requested Amount',
      },
      price: {
        id: 'productSummary.productInformation.price',
        defaultMessage: 'Price',
      },
      purchase_price_nada: {
        id: 'productSummary.productInformation.purchase_price_nada',
        defaultMessage: 'NADA Price',
      },
      purchase_price_invoice: {
        id: 'productSummary.productInformation.purchase_price_invoice',
        defaultMessage: 'Invoice Price',
      },
      year: {
        id: 'productSummary.productInformation.year',
        defaultMessage: 'Year',
      },
      sellingPriceDisclaimer: {
        id: 'productSummary.productInformation.sellingPriceDisclaimer',
        defaultMessage: 'Selling price + tax, title, and license',
      },
      condition: {
        id: 'productSummary.productInformation.condition',
        defaultMessage: 'Condition',
      },
      serial_number_HIN: {
        id: 'productSummary.productInformation.serial_number_HIN',
        defaultMessage: 'HIN',
      },
      serial_number_VIN: {
        id: 'productSummary.productInformation.serial_number_VIN',
        defaultMessage: 'VIN',
      },
      serial_number: {
        id: 'productSummary.productInformation.serial_number',
        defaultMessage: 'Serial Number',
      },
      asset_class: {
        id: 'productSummary.productInformation.asset_class',
        defaultMessage: 'Asset Class',
      },
      colour: {
        ktm: {
          id: 'productSummary.productInformation.colour.ktm',
          defaultMessage: 'MSRP/NADA',
        },
        brunswick: {
          id: 'productSummary.productInformation.colour.brunswick',
          defaultMessage: 'Invoice/NADA',
        },
        ezgo: {
          id: 'productSummary.productInformation.colour.ezgo',
          defaultMessage: 'MSRP/NADA',
        },
      },
      color: {
        id: 'productSummary.productInformation.color',
        defaultMessage: 'Color',
      },
    },
  },
});

export default messages;
